import React from 'react'
import { Category } from '../types/category'

interface CategoryFilterProps {
  categories: Category[]
  selectedCategoryId?: string
  onSelectCategory: (categoryId: string) => void
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategoryId,
  onSelectCategory,
}) => {
  return (
    <div
      className={`
      flex
      w-full
      gap-8px
      overflow-x-auto
      scrollbar-hide
      items-center
      px-20px
    `}
    >
      {categories.map((category) => {
        const isSelected = selectedCategoryId === category.id

        return (
          <button
            key={category.id}
            type="button"
            onClick={() => onSelectCategory(category.id)}
            className="whitespace-nowrap font-pretendard text-16px leading-none transition-all"
            // pill 형태 · 선택=진한 taupe 갈색 채움+흰 굵은 글씨 / 미선택=흰 배경+회색 글씨
            style={{
              flexShrink: 0,
              padding: '11px 16px',
              borderRadius: 12,
              border: 'none',
              backgroundColor: isSelected ? '#6B5E46' : '#FFFFFF',
              color: isSelected ? '#FFFFFF' : '#8C8375',
              fontWeight: isSelected ? 700 : 500,
              boxShadow: isSelected
                ? '0px 4px 10px 0px rgba(75, 54, 33, 0.25)'
                : '0px 4px 10px 0px rgba(117, 76, 0, 0.12)',
            }}
          >
            {category.label}
          </button>
        )
      })}
    </div>
  )
}

export default CategoryFilter
